"use strict";

angular.module("models").service("ElearningCampaignsService", ["ApiService", function (ApiService) {
  var that = this;

  angular.extend(that, ApiService.getModel("elearningCampaigns", ["name"], function (element) {
    return "???";
  }));
}]);